import { computed, onUnmounted, ref, type ComputedRef, type Ref } from 'vue'
import type { IConfDocjson, IConfDocjsonDili } from '@/modules/Configuracion/interfaces'
import { docJsonService, docJsonDiligenciadosService } from '@/services';
import type { ICitaDocjson } from '@/modules/Asistencial/interfaces';
const dataListDocumentos = ref<IConfDocjson[]>([])
const listDocumentosDiligenciados = ref<ICitaDocjson[]>([])
const listDocumentos = computed(()=>{
   return dataListDocumentos.value.filter(doc => !listDocumentosDiligenciados.value.some(diligenciado => diligenciado.cifoCodigo === doc.cofoCodigo && diligenciado.cifoTipoDocumento === doc.cofoTipoDocumento))
})
const docSeleccionado = ref<IConfDocjsonDili | null>(null)
export function useDocumentosDiligenciar(origen?: string): {
  dataListDocumentos: Ref<IConfDocjson[]>;
  listDocumentosDiligenciados: Ref<ICitaDocjson[]>;
  listDocumentos: ComputedRef<IConfDocjson[]>;
  docSeleccionado: Ref<IConfDocjsonDili | null>;
  getDiligenciados: (params: {tablaId: number, tablaOrigen: string, cofoTipoDocumento: string}) => Promise<void>;
  getDocumentos: (params: { cofoSitioDiligencia: string | null; coseId: number | null; cocuId: number | null; cofoTipoDocumento: string; sinServicio?: boolean; ciadTipoEstado?: string | null; }) => Promise<void>;
  setDocSeleccionado: (doc: IConfDocjsonDili | null) => void;
  getDocSeleccionado: () => IConfDocjsonDili | null;
  setDiligenciado: (item: ICitaDocjson) => void;
} {
  const getDiligenciados = async ({tablaId, tablaOrigen, cofoTipoDocumento}: {tablaId: number, tablaOrigen: string, cofoTipoDocumento: string}) => {
    const { data } = await docJsonDiligenciadosService.list({ tablaId, tablaOrigen, cifoTipoDocumento: cofoTipoDocumento })
    listDocumentosDiligenciados.value = data.body
  }
  const getDocumentos = async ({cofoTipoDocumento, cofoSitioDiligencia, coseId, cocuId, sinServicio, ciadTipoEstado}: {cofoSitioDiligencia: string | null, coseId: number | null, cocuId: number | null,cofoTipoDocumento: string, sinServicio?: boolean, ciadTipoEstado?: string | null}) => {
    const params: Record<string, unknown> = { cofoTipoDocumento, cofoSitioDiligencia, coseId, cocuId }
    if (sinServicio) params.sinServicio = true
    if (ciadTipoEstado) params.ciadTipoEstado = ciadTipoEstado
    const { data } = await docJsonService.list(params)
    dataListDocumentos.value = data.body
  }

  const setDocSeleccionado = (doc: IConfDocjsonDili | null) => {
    docSeleccionado.value = doc
  }
  const getDocSeleccionado = () => {
    return docSeleccionado.value
  }
  const setDiligenciado = (item: ICitaDocjson) => {
    listDocumentosDiligenciados.value.push(item)
  }
  const resetState = () => {
     if(origen === 'principal'){
      dataListDocumentos.value = []
      listDocumentosDiligenciados.value = []
     }
  }
    // limpiar siempre que el componente se desmonte
  onUnmounted(resetState)
  return { dataListDocumentos, listDocumentosDiligenciados, listDocumentos, docSeleccionado, getDiligenciados, getDocumentos, setDocSeleccionado, getDocSeleccionado,  setDiligenciado}
}
